import { ApiBase } from './ApiBase';
class OfferCategoryApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getOfferCategory = (id, params) => {
            return this.get(`/offer-categories/${id}`, params);
        };
        this.getVerticalOfferCategories = (params) => {
            return this.get('/offer-categories/verticals', params);
        };
        this.searchOfferCategories = (params) => {
            return this.get('/offer-categories/search', params);
        };
    }
}
export const OfferCategoryApiClient = new OfferCategoryApiClientModel();
